module.exports = __webpack_public_path__ + "static/img/file_stylus.440be10d.png";